$(function() {

	var $alerts = $('.main-alert .alert'),
		duration = 5000;

	// Show
	if ($alerts.length) {
		setTimeout(function() {
			$alerts.addClass('visible');

			// Hide and remove
			setTimeout(function() {
				$alerts.removeClass('visible');
				setTimeout(function() {
					$alerts.remove();
				}, 300);
			}, duration);
			
		}, 100);
	}

	// Click to remove
	$alerts.click(function() {
		$(this).remove();
	});

});